export default __webpack_public_path__ + "55c0cde02b59233e0370008f57ba87e0.png";